import { BackspaceOutlineIcon } from './BackspaceOutlineIcon';

/**
 * author: Google
 * id 7CD351DA-560B-42B5-86F3-7F782EA70FEA
 * name backspace-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backspace-outline.svg
 * tags
 */
export const EraseOutlineIcon = BackspaceOutlineIcon;
export default EraseOutlineIcon